import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';

/**
 * 查询 数据权限
 */
export function queryNoticeAuthority(_x) {
  return _queryNoticeAuthority.apply(this, arguments);
}
/**
 * 新增编辑 数据权限
 */
function _queryNoticeAuthority() {
  _queryNoticeAuthority = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request("/notice/queryNoticeAuthority", METHOD.POST, data));
      }
    }, _callee);
  }));
  return _queryNoticeAuthority.apply(this, arguments);
}
export function saveNoticeAuthority(_x2) {
  return _saveNoticeAuthority.apply(this, arguments);
}
/**
 * 查询数据权限详情
 */
function _saveNoticeAuthority() {
  _saveNoticeAuthority = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request("/notice/saveNoticeAuthority", METHOD.POST, data));
      }
    }, _callee2);
  }));
  return _saveNoticeAuthority.apply(this, arguments);
}
export function queryNoticeAuthorityDetails(_x3) {
  return _queryNoticeAuthorityDetails.apply(this, arguments);
}
/**
 * 查询数据权限岗位
 */
function _queryNoticeAuthorityDetails() {
  _queryNoticeAuthorityDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(authId) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request("/notice/queryNoticeAuthorityDetails", METHOD.POST, {
            authId: authId
          }));
      }
    }, _callee3);
  }));
  return _queryNoticeAuthorityDetails.apply(this, arguments);
}
export function queryAuthority(_x4) {
  return _queryAuthority.apply(this, arguments);
}
/**
 * 新增编辑通知公告(需要走审批流程)
 * 接口文档http://43.136.181.215:4999/web/#/48/2907
 */
function _queryAuthority() {
  _queryAuthority = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request("/notice/queryAuthority", METHOD.POST, data));
      }
    }, _callee4);
  }));
  return _queryAuthority.apply(this, arguments);
}
export function saveNoticeFill(_x5) {
  return _saveNoticeFill.apply(this, arguments);
}
/**
 * 查询通知公告发送范围
 * 接口文档http://43.136.181.215:4999/web/#/48/2908
 */
function _saveNoticeFill() {
  _saveNoticeFill = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, request("/notice/saveNoticeFill", METHOD.POST, data));
      }
    }, _callee5);
  }));
  return _saveNoticeFill.apply(this, arguments);
}
export function queryAuthorityScope(_x6) {
  return _queryAuthorityScope.apply(this, arguments);
}
/**
 * 通知公告详情
 */
function _queryAuthorityScope() {
  _queryAuthorityScope = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(data) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, request("/notice/queryAuthorityScope", METHOD.POST, data));
      }
    }, _callee6);
  }));
  return _queryAuthorityScope.apply(this, arguments);
}
export function queryNoticeFillDetails(_x7) {
  return _queryNoticeFillDetails.apply(this, arguments);
}
/**
 * 撤回通知公告
 * 接口文档http://43.136.181.215:4999/web/#/48/2909
 */
function _queryNoticeFillDetails() {
  _queryNoticeFillDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(id) {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          return _context7.a(2, request("/notice/queryNoticeFillDetails", METHOD.POST, {
            id: id
          }));
      }
    }, _callee7);
  }));
  return _queryNoticeFillDetails.apply(this, arguments);
}
export function withdrawNotice(_x8) {
  return _withdrawNotice.apply(this, arguments);
}
/**
 * 删除通知公告
 * 接口文档http://43.136.181.215:4999/web/#/48/2910
 */
function _withdrawNotice() {
  _withdrawNotice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(id) {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          return _context8.a(2, request("/notice/withdrawNotice", METHOD.POST, {
            id: id
          }));
      }
    }, _callee8);
  }));
  return _withdrawNotice.apply(this, arguments);
}
export function delNotice(_x9) {
  return _delNotice.apply(this, arguments);
}
/**
 * 发布通知公告
 * 接口文档http://43.136.181.215:4999/web/#/48/3005
 */
function _delNotice() {
  _delNotice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(id) {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, request("/notice/delNotice", METHOD.POST, {
            id: id
          }));
      }
    }, _callee9);
  }));
  return _delNotice.apply(this, arguments);
}
export function releaseNotice(_x0) {
  return _releaseNotice.apply(this, arguments);
}
/**
 * 提交公告
 * 接口文档http://43.136.181.215:4999/web/#/48/2952
 */
function _releaseNotice() {
  _releaseNotice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(id) {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          return _context0.a(2, request("/notice/releaseNotice", METHOD.POST, {
            id: id
          }));
      }
    }, _callee0);
  }));
  return _releaseNotice.apply(this, arguments);
}
export function submitNotice(_x1) {
  return _submitNotice.apply(this, arguments);
}
/**
 * 启用停用通知公告
 * 接口文档http://43.136.181.215:4999/web/#/48/2911
 */
function _submitNotice() {
  _submitNotice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(data) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          return _context1.a(2, request("/notice/submitNotice", METHOD.POST, {
            id: data.id,
            range: data.range,
            typeId: data.typeId,
            organId: data.organId,
            isCehck: data.isCehck
          }));
      }
    }, _callee1);
  }));
  return _submitNotice.apply(this, arguments);
}
export function enableNotice(_x10) {
  return _enableNotice.apply(this, arguments);
}
/**
 * 查询公告分类
 * 接口文档http://43.136.181.215:4999/web/#/48/2913
 */
function _enableNotice() {
  _enableNotice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(id) {
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          return _context10.a(2, request("/notice/enableNotice", METHOD.POST, {
            id: id
          }));
      }
    }, _callee10);
  }));
  return _enableNotice.apply(this, arguments);
}
export function queryNoticeCate(_x11) {
  return _queryNoticeCate.apply(this, arguments);
}
/**
 * 查询公告记录
 * 接口文档http://43.136.181.215:4999/web/#/48/2914
 */
function _queryNoticeCate() {
  _queryNoticeCate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(data) {
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          return _context11.a(2, request("/notice/queryNoticeCate", METHOD.POST, data));
      }
    }, _callee11);
  }));
  return _queryNoticeCate.apply(this, arguments);
}
export function queryNoticeFill(_x12, _x13, _x14) {
  return _queryNoticeFill.apply(this, arguments);
}
/**
 * 查询公告附件
 * 接口文档http://43.136.181.215:4999/web/#/48/2915
 */
function _queryNoticeFill() {
  _queryNoticeFill = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(page, limit, param) {
    var data;
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            cateId: param.cateId,
            title: param.title,
            emergency: param.emergency,
            startTime: param.startTime,
            endTime: param.endTime
          };
          return _context12.a(2, request("/notice/queryNoticeFill", METHOD.POST, data));
      }
    }, _callee12);
  }));
  return _queryNoticeFill.apply(this, arguments);
}
export function queryAttach(_x15) {
  return _queryAttach.apply(this, arguments);
}
/**
 * 查询公告接收范围
 * 接口文档http://43.136.181.215:4999/web/#/48/2916
 */
function _queryAttach() {
  _queryAttach = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(data) {
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          return _context13.a(2, request("/notice/queryAttach", METHOD.POST, data));
      }
    }, _callee13);
  }));
  return _queryAttach.apply(this, arguments);
}
export function queryRecord(_x16) {
  return _queryRecord.apply(this, arguments);
}
/**
 * 在通知公告选择发送范围的时判断是否能选择全校
 * 接口文档http://43.136.181.215:4999/web/#/48/2919
 */
function _queryRecord() {
  _queryRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(data) {
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.n) {
        case 0:
          return _context14.a(2, request("/notice/queryRecord", METHOD.POST, data));
      }
    }, _callee14);
  }));
  return _queryRecord.apply(this, arguments);
}
export function querySendOutScope(_x17) {
  return _querySendOutScope.apply(this, arguments);
}
/**
 * 添加加签
 * 接口文档http://43.136.181.215:4999/web/#/48/2927
 */
function _querySendOutScope() {
  _querySendOutScope = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(data) {
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          return _context15.a(2, request("/notice/querySendOutScope", METHOD.POST, data));
      }
    }, _callee15);
  }));
  return _querySendOutScope.apply(this, arguments);
}
export function addAppendAudit(_x18) {
  return _addAppendAudit.apply(this, arguments);
}
/**
 * 通知公告审核（查询审核）
 * 接口文档http://43.136.181.215:4999/web/#/48/2928
 */
function _addAppendAudit() {
  _addAppendAudit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(data) {
    return _regenerator().w(function (_context16) {
      while (1) switch (_context16.n) {
        case 0:
          return _context16.a(2, request("/notice/addAppendAudit", METHOD.POST, data));
      }
    }, _callee16);
  }));
  return _addAppendAudit.apply(this, arguments);
}
export function queryExamine(_x19, _x20, _x21) {
  return _queryExamine.apply(this, arguments);
}
/**
 * 审核
 * 接口文档http://43.136.181.215:4999/web/#/48/2930
 */
function _queryExamine() {
  _queryExamine = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(page, limit, param) {
    var data;
    return _regenerator().w(function (_context17) {
      while (1) switch (_context17.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            cateId: param.cateId,
            query: param.query,
            emergency: param.emergency,
            auditStatus: param.auditStatus
          };
          return _context17.a(2, request("/notice/queryExamine", METHOD.POST, data));
      }
    }, _callee17);
  }));
  return _queryExamine.apply(this, arguments);
}
export function noticeExamine(_x22) {
  return _noticeExamine.apply(this, arguments);
}
/**
 * 查阅情况
 * 接口文档http://43.136.181.215:4999/web/#/48/2947
 */
function _noticeExamine() {
  _noticeExamine = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(data) {
    return _regenerator().w(function (_context18) {
      while (1) switch (_context18.n) {
        case 0:
          return _context18.a(2, request("/notice/noticeExamine", METHOD.POST, data));
      }
    }, _callee18);
  }));
  return _noticeExamine.apply(this, arguments);
}
export function queryConsult(_x23) {
  return _queryConsult.apply(this, arguments);
}
/**
 * 查询审核记录
 * 接口文档http://43.136.181.215:4999/web/#/48/2951
 */
function _queryConsult() {
  _queryConsult = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(data) {
    return _regenerator().w(function (_context19) {
      while (1) switch (_context19.n) {
        case 0:
          return _context19.a(2, request("/notice/queryConsult", METHOD.POST, data));
      }
    }, _callee19);
  }));
  return _queryConsult.apply(this, arguments);
}
export function queryAuditRecord(_x24) {
  return _queryAuditRecord.apply(this, arguments);
}
/**
 * 通知公告管理（查询通过后的通知公告）
 * 接口文档http://43.136.181.215:4999/web/#/48/3042
 */
function _queryAuditRecord() {
  _queryAuditRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(id) {
    return _regenerator().w(function (_context20) {
      while (1) switch (_context20.n) {
        case 0:
          return _context20.a(2, request("/notice/queryAuditRecord", METHOD.POST, {
            id: id
          }));
      }
    }, _callee20);
  }));
  return _queryAuditRecord.apply(this, arguments);
}
export function queryNoticeFillAdopt(_x25, _x26, _x27) {
  return _queryNoticeFillAdopt.apply(this, arguments);
}
/**
 * 查阅情况按人员
 * 接口文档http://43.136.181.215:4999/web/#/48/2947
 */
function _queryNoticeFillAdopt() {
  _queryNoticeFillAdopt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(page, limit, param) {
    var data;
    return _regenerator().w(function (_context21) {
      while (1) switch (_context21.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            status: param.status,
            cateId: param.cateId,
            title: param.title,
            emergency: param.emergency,
            startTime: param.startTime,
            endTime: param.endTime
          };
          return _context21.a(2, request("/notice/queryNoticeFillAdopt", METHOD.POST, data));
      }
    }, _callee21);
  }));
  return _queryNoticeFillAdopt.apply(this, arguments);
}
export function queryConsultUser(_x28, _x29, _x30) {
  return _queryConsultUser.apply(this, arguments);
}
/**
 * 查阅情况按岗位
 * 接口文档http://43.136.181.215:4999/web/#/48/2990
 */
function _queryConsultUser() {
  _queryConsultUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(page, limit, param) {
    var data;
    return _regenerator().w(function (_context22) {
      while (1) switch (_context22.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            mobile: param.mobile,
            query: param.query,
            fillId: param.fillId
          };
          return _context22.a(2, request("/notice/queryConsultUser", METHOD.POST, data));
      }
    }, _callee22);
  }));
  return _queryConsultUser.apply(this, arguments);
}
export function queryConsultPost(_x31, _x32, _x33) {
  return _queryConsultPost.apply(this, arguments);
}
/**
 * 查阅情况按组织
 * 接口文档http://43.136.181.215:4999/web/#/48/2991
 */
function _queryConsultPost() {
  _queryConsultPost = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(page, limit, param) {
    var data;
    return _regenerator().w(function (_context23) {
      while (1) switch (_context23.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            mobile: param.mobile,
            query: param.query,
            fillId: param.fillId
          };
          return _context23.a(2, request("/notice/queryConsultPost", METHOD.POST, data));
      }
    }, _callee23);
  }));
  return _queryConsultPost.apply(this, arguments);
}
export function queryConsultOrgan(_x34, _x35, _x36) {
  return _queryConsultOrgan.apply(this, arguments);
}
/**
 * 判断能否加签
 * 接口文档http://43.136.181.215:4999/web/#/48/3071
 */
function _queryConsultOrgan() {
  _queryConsultOrgan = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(page, limit, param) {
    var data;
    return _regenerator().w(function (_context24) {
      while (1) switch (_context24.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            mobile: param.mobile,
            query: param.query,
            fillId: param.fillId
          };
          return _context24.a(2, request("/notice/queryConsultOrgan", METHOD.POST, data));
      }
    }, _callee24);
  }));
  return _queryConsultOrgan.apply(this, arguments);
}
export function judgeCountersign(_x37) {
  return _judgeCountersign.apply(this, arguments);
}
/**
 * 判断能否追加
 * 接口文档http://43.136.181.215:4999/web/#/48/3083
 */
function _judgeCountersign() {
  _judgeCountersign = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(id) {
    return _regenerator().w(function (_context25) {
      while (1) switch (_context25.n) {
        case 0:
          return _context25.a(2, request("/notice/judgeCountersign", METHOD.POST, {
            id: id
          }));
      }
    }, _callee25);
  }));
  return _judgeCountersign.apply(this, arguments);
}
export function judgeAppend(_x38) {
  return _judgeAppend.apply(this, arguments);
}
/**
 * 查询可以反馈数据
 * 接口文档http://43.136.181.215:4999/web/#/48/3106
 */
function _judgeAppend() {
  _judgeAppend = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(id) {
    return _regenerator().w(function (_context26) {
      while (1) switch (_context26.n) {
        case 0:
          return _context26.a(2, request("/notice/judgeAppend", METHOD.POST, {
            id: id
          }));
      }
    }, _callee26);
  }));
  return _judgeAppend.apply(this, arguments);
}
export function queryNoticeFeedBack(_x39, _x40, _x41) {
  return _queryNoticeFeedBack.apply(this, arguments);
}
/**
 * 新增反馈
 * 接口文档http://43.136.181.215:4999/web/#/48/3006
 */
function _queryNoticeFeedBack() {
  _queryNoticeFeedBack = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(page, limit, param) {
    var data;
    return _regenerator().w(function (_context27) {
      while (1) switch (_context27.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            cateId: param.cateId,
            title: param.title,
            emergency: param.emergency,
            startTime: param.startTime,
            endTime: param.endTime
          };
          return _context27.a(2, request("/notice/queryNoticeFeedBack", METHOD.POST, data));
      }
    }, _callee27);
  }));
  return _queryNoticeFeedBack.apply(this, arguments);
}
export function saveFeedBack(_x42) {
  return _saveFeedBack.apply(this, arguments);
}
/**
 * 查询可以反馈数据
 * 接口文档http://43.136.181.215:4999/web/#/48/3110
 */
function _saveFeedBack() {
  _saveFeedBack = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(data) {
    return _regenerator().w(function (_context28) {
      while (1) switch (_context28.n) {
        case 0:
          return _context28.a(2, request("/notice/saveFeedBack", METHOD.POST, data));
      }
    }, _callee28);
  }));
  return _saveFeedBack.apply(this, arguments);
}
export function queryFeedBackExamine(_x43, _x44, _x45) {
  return _queryFeedBackExamine.apply(this, arguments);
}
/**
 * 根据公告查询需要审核的反馈记录
 * 接口文档http://43.136.181.215:4999/web/#/48/3109
 */
function _queryFeedBackExamine() {
  _queryFeedBackExamine = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(page, limit, param) {
    var data;
    return _regenerator().w(function (_context29) {
      while (1) switch (_context29.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            cateId: param.cateId,
            title: param.title,
            emergency: param.emergency,
            startTime: param.startTime,
            endTime: param.endTime
          };
          return _context29.a(2, request("/notice/queryFeedBackExamine", METHOD.POST, data));
      }
    }, _callee29);
  }));
  return _queryFeedBackExamine.apply(this, arguments);
}
export function queryFeedBackExamineRecord(_x46, _x47, _x48) {
  return _queryFeedBackExamineRecord.apply(this, arguments);
}
/**
 * 根据公告id查询反馈信息
 * 接口文档http://43.136.181.215:4999/web/#/48/3107
 */
function _queryFeedBackExamineRecord() {
  _queryFeedBackExamineRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(page, limit, param) {
    var data;
    return _regenerator().w(function (_context30) {
      while (1) switch (_context30.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            fillId: param.fillId,
            query: param.query,
            status: param.status
          };
          return _context30.a(2, request("/notice/queryFeedBackExamineRecord", METHOD.POST, data));
      }
    }, _callee30);
  }));
  return _queryFeedBackExamineRecord.apply(this, arguments);
}
export function queryFeedBack(_x49) {
  return _queryFeedBack.apply(this, arguments);
}
/**
 * 反馈审核
 * 接口文档http://43.136.181.215:4999/web/#/48/3108
 */
function _queryFeedBack() {
  _queryFeedBack = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(id) {
    return _regenerator().w(function (_context31) {
      while (1) switch (_context31.n) {
        case 0:
          return _context31.a(2, request("/notice/queryFeedBack", METHOD.POST, {
            id: id
          }));
      }
    }, _callee31);
  }));
  return _queryFeedBack.apply(this, arguments);
}
export function examineFeedback(_x50) {
  return _examineFeedback.apply(this, arguments);
}
/**
 * 查询反馈审核记录
 * 接口文档http://43.136.181.215:4999/web/#/48/3111
 */
function _examineFeedback() {
  _examineFeedback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(data) {
    return _regenerator().w(function (_context32) {
      while (1) switch (_context32.n) {
        case 0:
          return _context32.a(2, request("/notice/examineFeedback", METHOD.POST, data));
      }
    }, _callee32);
  }));
  return _examineFeedback.apply(this, arguments);
}
export function queryFeedAuditRecord(_x51) {
  return _queryFeedAuditRecord.apply(this, arguments);
}
/**
 * 查询反馈审核记录(驳回)
 * 接口文档http://43.136.181.215:4999/web/#/48/3132
 */
function _queryFeedAuditRecord() {
  _queryFeedAuditRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(id) {
    return _regenerator().w(function (_context33) {
      while (1) switch (_context33.n) {
        case 0:
          return _context33.a(2, request("/notice/queryFeedAuditRecord", METHOD.POST, {
            id: id
          }));
      }
    }, _callee33);
  }));
  return _queryFeedAuditRecord.apply(this, arguments);
}
export function queryFeedAuditRecordRec(_x52) {
  return _queryFeedAuditRecordRec.apply(this, arguments);
}
/**
 * 判断财务室主任提交时是否需要财务总监审核
 * 接口文档http://43.136.181.215:4999/web/#/48/3187
 */
function _queryFeedAuditRecordRec() {
  _queryFeedAuditRecordRec = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee34(id) {
    return _regenerator().w(function (_context34) {
      while (1) switch (_context34.n) {
        case 0:
          return _context34.a(2, request("/notice/queryFeedAuditRecordRec", METHOD.POST, {
            id: id
          }));
      }
    }, _callee34);
  }));
  return _queryFeedAuditRecordRec.apply(this, arguments);
}
export function judgeDirector(_x53) {
  return _judgeDirector.apply(this, arguments);
}
/**
 * 判断财务室主任审核时是否需要财务总监审核(审核)
 * 接口文档http://43.136.181.215:4999/web/#/48/3231
 */
function _judgeDirector() {
  _judgeDirector = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee35(data) {
    return _regenerator().w(function (_context35) {
      while (1) switch (_context35.n) {
        case 0:
          return _context35.a(2, request("/notice/judgeDirector", METHOD.POST, data));
      }
    }, _callee35);
  }));
  return _judgeDirector.apply(this, arguments);
}
export function judgeDirectorExamine(_x54) {
  return _judgeDirectorExamine.apply(this, arguments);
}
/**
 * 判断是否是纪委办主任
 * 接口文档http://43.136.181.215:4999/web/#/48/3202
 */
function _judgeDirectorExamine() {
  _judgeDirectorExamine = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee36(id) {
    return _regenerator().w(function (_context36) {
      while (1) switch (_context36.n) {
        case 0:
          return _context36.a(2, request("/notice/judgeDirectorExamine", METHOD.POST, {
            id: id
          }));
      }
    }, _callee36);
  }));
  return _judgeDirectorExamine.apply(this, arguments);
}
export function judgeDirectorJWB(_x55) {
  return _judgeDirectorJWB.apply(this, arguments);
}
/**
 * 判断纪委办主任(审核)
 * 接口文档http://43.136.181.215:4999/web/#/48/3232
 */
function _judgeDirectorJWB() {
  _judgeDirectorJWB = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee37(data) {
    return _regenerator().w(function (_context37) {
      while (1) switch (_context37.n) {
        case 0:
          return _context37.a(2, request("/notice/judgeDirectorJWB", METHOD.POST, data));
      }
    }, _callee37);
  }));
  return _judgeDirectorJWB.apply(this, arguments);
}
export function judgeDirectorExamineJWB(_x56) {
  return _judgeDirectorExamineJWB.apply(this, arguments);
}
/**
 * 判断是否需要校长理事长审核(财务总监)
 * 接口文档http://43.136.181.215:4999/web/#/48/3188
 */
function _judgeDirectorExamineJWB() {
  _judgeDirectorExamineJWB = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee38(id) {
    return _regenerator().w(function (_context38) {
      while (1) switch (_context38.n) {
        case 0:
          return _context38.a(2, request("/notice/judgeDirectorExamineJWB", METHOD.POST, {
            id: id
          }));
      }
    }, _callee38);
  }));
  return _judgeDirectorExamineJWB.apply(this, arguments);
}
export function judgeAppendFinance(_x57) {
  return _judgeAppendFinance.apply(this, arguments);
}
/**
 * 根据公告id查询本人反馈信息
 * 接口文档http://43.136.181.215:4999/web/#/48/3225
 */
function _judgeAppendFinance() {
  _judgeAppendFinance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee39(id) {
    return _regenerator().w(function (_context39) {
      while (1) switch (_context39.n) {
        case 0:
          return _context39.a(2, request("/notice/judgeAppendFinance", METHOD.POST, {
            id: id
          }));
      }
    }, _callee39);
  }));
  return _judgeAppendFinance.apply(this, arguments);
}
export function queryFeedBackByUser(_x58) {
  return _queryFeedBackByUser.apply(this, arguments);
}
/**
 * 查询加签记录
 * 接口文档http://43.136.181.215:4999/web/#/48/3229
 */
function _queryFeedBackByUser() {
  _queryFeedBackByUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee40(id) {
    return _regenerator().w(function (_context40) {
      while (1) switch (_context40.n) {
        case 0:
          return _context40.a(2, request("/notice/queryFeedBackByUser", METHOD.POST, {
            id: id
          }));
      }
    }, _callee40);
  }));
  return _queryFeedBackByUser.apply(this, arguments);
}
export function querySign(_x59) {
  return _querySign.apply(this, arguments);
}

/**
 * 新增编辑通知公告(不需要走审批流程)
 * 接口文档http://43.136.181.215:4999/web/#/48/2907
 */
function _querySign() {
  _querySign = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee41(data) {
    return _regenerator().w(function (_context41) {
      while (1) switch (_context41.n) {
        case 0:
          return _context41.a(2, request("/notice/querySign", METHOD.POST, data));
      }
    }, _callee41);
  }));
  return _querySign.apply(this, arguments);
}
export function saveNoticeFillNoCheck(_x60) {
  return _saveNoticeFillNoCheck.apply(this, arguments);
}
function _saveNoticeFillNoCheck() {
  _saveNoticeFillNoCheck = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee42(data) {
    return _regenerator().w(function (_context42) {
      while (1) switch (_context42.n) {
        case 0:
          return _context42.a(2, request("/notice/saveNoticeFillNoCheck", METHOD.POST, data));
      }
    }, _callee42);
  }));
  return _saveNoticeFillNoCheck.apply(this, arguments);
}